"use client";
import type { ComponentType, ReactElement } from "react";
import { DEFAULT_CSEGMENTED_PANEL_VARIANT } from "./csegmentedpanel.constants";
import { CsegmentedpanelInsetCells } from "./CsegmentedpanelInsetCells";
import { CsegmentedpanelLabelBands } from "./CsegmentedpanelLabelBands";
import { CsegmentedpanelSeamed } from "./CsegmentedpanelSeamed";
import { CsegmentedpanelSignalRails } from "./CsegmentedpanelSignalRails";
import {
  CsegmentedpanelVariant,
  type CsegmentedpanelProps,
  type CsegmentedpanelVariantProps,
} from "./csegmentedpanel.types";

const CSEGMENTED_PANEL_COMPONENT: Record<
  CsegmentedpanelVariant,
  ComponentType<CsegmentedpanelVariantProps>
> = {
  [CsegmentedpanelVariant.Seamed]: CsegmentedpanelSeamed,
  [CsegmentedpanelVariant.InsetCells]: CsegmentedpanelInsetCells,
  [CsegmentedpanelVariant.SignalRails]: CsegmentedpanelSignalRails,
  [CsegmentedpanelVariant.LabelBands]: CsegmentedpanelLabelBands,
};

export function Csegmentedpanel({
  columns = 3,
  items,
  style,
  variant = DEFAULT_CSEGMENTED_PANEL_VARIANT,
}: CsegmentedpanelProps): ReactElement {
  const VariantComponent = CSEGMENTED_PANEL_COMPONENT[variant];
  return <VariantComponent columns={columns} items={items} style={style} />;
}
